import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CommonHttpService } from '../commonHttp.service';
import { LoaderService } from '../../_shared/services/loader.service';
import { AddToCartService } from '../../_shared/services/add-to-cart.service';
import { AuthService } from "angularx-social-login";
import { FacebookLoginProvider, GoogleLoginProvider } from "angularx-social-login";
import { PhonePe } from "phonepesdk-web";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  baseUrl: any = environment.apiUrl;
  user: any = {};
  responseMessage: any = '';
  socialUser: any;
  ppavl: boolean;
  response: any;
  responseUserDetails: any;
  userDetails: any;
  isLoggedIn: boolean;
  param1: string;
  redirectionParamUrl: any;
  isNavigateToOrderDetail: boolean = false
  constructor(private service: CommonHttpService,
    private http: HttpClient, private addToCartService: AddToCartService, private router: Router, private route: ActivatedRoute, private loaderService: LoaderService, private authService: AuthService) { }

  ngOnInit() {
    this.param1 = this.route.snapshot.queryParamMap.get('utm_source');
    if (this.param1 == "navigateToOrderDetails") {
      this.redirectionParamUrl = this.route.snapshot.queryParamMap.get('navigateUrl');
      console.log(this.redirectionParamUrl)
      this.isNavigateToOrderDetail = true
      console.log(this.isNavigateToOrderDetail)
    }
    let IsPhonepe = JSON.parse(localStorage.getItem("utm_sources"));
    if (localStorage.getItem("isLoggedin")) {
      this.isLoggedIn = true;
    }
    console.log(IsPhonepe);
    if (IsPhonepe == "phonepe") {
      this.ppavl = true;
    }
    console.log(localStorage.getItem("isLoggedin"))
    console.log(this.ppavl)
    let hasPopupShown = localStorage.getItem("hasPopupShown")
    console.log(hasPopupShown)
    console.log(this.ppavl)
    console.log(this.isLoggedIn)
    if (this.ppavl == true && this.isLoggedIn == null && hasPopupShown != "true") {
      console.log("show popup");
      this.showPopupForPhonepeLogin()

    }
    window.scrollTo(0, 0);
  }

  signInWithGoogle(): void {
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  signInWithFB(): void {
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
  }

  signOut(): void {
    this.authService.signOut();
  }

  login() {
    this.user.LoginType = "Normal"
    this.loaderService.display(true);

    this.service.create(this.baseUrl + 'LoginAPI/Login', this.user)
      .subscribe(
        data => {
          console.log(data)
          if (data.statusCode == 1) {
            localStorage.setItem('customerId', data.customerId);
            localStorage.setItem('customerName', data.customerName);
            localStorage.setItem('isLoggedin', 'true');
            //this.addToCartService.login();

            if (this.isNavigateToOrderDetail == true) {
              console.log("called 88")
              //  this.addToCartService.getCartDetailsAfterLoginPhonepe();
              console.log(this.redirectionParamUrl)
              //this.router.navigate([this.redirectionParamUrl])
              window.location.href = this.redirectionParamUrl
            }
            else if (this.ppavl == true) {
              this.addToCartService.getCartDetailsAfterLoginPhonepe();
              console.log("add to cart service Phonepe")


            }
            else {
              this.addToCartService.getCartDetailsAfterLogin()
              //this.loaderService.display(false);

            }

          }
          else {
            this.responseMessage = data.responseMessage;
            this.loaderService.display(false);
          }
        },
        (error) => {
          this.loaderService.display(false);
        })
  }

  FBLogin() {
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID).then(() => {
      this.authService.authState.subscribe((user) => {
        this.socialUser = user;
        console.log(this.socialUser);
        this.sendSocialLoginData('Facebook');
      });
    });
  }

  GoogleLogin() {
    //localStorage.removeItem('userId');
    //this.user = null
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID).then(() => {
      this.authService.authState.subscribe((user) => {
        this.socialUser = user;
        console.log(this.socialUser);
        this.sendSocialLoginData('Google');
      });
    });
  }

  sendSocialLoginData(loginType) {
    let sendData = { Email: this.socialUser.email, LoginType: loginType, Password: this.socialUser.id, SocialId: this.socialUser.id, CustomerName: this.socialUser.name, CustomerGroupId: 11 }
    this.service.create(this.baseUrl + 'LoginAPI/SocialLogin', sendData)
      .subscribe(
        data => {
          this.loaderService.display(true);
          console.log(data)
          if (data.statusCode == 1) {
            localStorage.setItem('customerId', data.customerId);
            localStorage.setItem('customerName', data.customerName);
            localStorage.setItem('isLoggedin', 'true');
            this.addToCartService.getCartDetailsAfterLogin();
          }
          else {
            this.responseMessage = data.responseMessage;
            this.loaderService.display(false);
          }
        },
        (error) => {
          this.loaderService.display(false);
        })
  }


  showPopupForPhonepeLogin() {
    PhonePe.PhonePe.build(PhonePe.Constants.Species.web).then((sdk) => {
      sdk
        .fetchAuthToken()
        .then((res) => {
          console.log(res);
          //   localStorage.setItem("isPopupshown", "true")
          //   alert(res.grantToken)
          // console.log(JSON.stringify(res));
          // var str = '{"grantToken":"' + res.grantToken + '"}';
          // console.log(str);
          // var encodedData = window.btoa(str);
          // console.log(encodedData);
          // this.encodedBase64 = encodedData;
          // let shaObj = new jsSHA("SHA-256", "TEXT");
          // shaObj.update(
          //   encodedData +
          //   "/v3/service/auth/access" +
          //   "ee3c4a1c-a1b3-48c2-840a-b4b513b132d7"
          // );
          // let hash1 = shaObj.getHash("HEX");
          // var hash = hash1.toUpperCase();
          // console.log(hash1);
          // console.log(hash);


          this.fetchAccessToken(res.grantToken);
        })
        .catch((err) => {
          console.log(
            //{"error_code":"USER_SKIPPED","description":"User skipped"}
            "Error occurred while fetching the grant token: " + err
          );
          let error = JSON.parse(err);
          if (error.error_code == "USER_SKIPPED") {
            console.log("has popup shown set")
            localStorage.setItem("hasPopupShown", "true")
            //  this.router.navigate(["login"], { queryParams: { utm_source: 'phonepe' } });
          }
          //  alert(err);
        });
    });
  }
  fetchAccessToken(base64body) {
    //  var xVerifyHeader = hash + "###" + 1;
    //  console.log(xVerifyHeader);
    var myobj = {
      request: base64body,
      XVERIFY: "test",
    };
    console.log(myobj);
    this.loaderService.display(true);
    this.http
      .post(this.baseUrl + "LoginAPI/PhonepeLoginAsync/", myobj)
      .subscribe(
        (data) => {
          this.response = data;
          console.log(this.response)

          this.loaderService.display(false);

          //   alert(this.response)
          // console.log(this.Response.data.accessToken);
          // let shaObj = new jsSHA("SHA-256", "TEXT");
          // shaObj.update(
          //   "/v3/service/userdetails" + "ee3c4a1c-a1b3-48c2-840a-b4b513b132d7"
          // );
          // let hash1 = shaObj.getHash("HEX");
          // var hash = hash1.toUpperCase();
          // console.log(hash1);
          // console.log(hash);
          // var xVerifyHeader = hash + "###" + 1;
          this.getUserDetails(this.response.data.accessToken);
        },
        (error: any) => {
          console.log(error);
          this.loaderService.display(false);

        }
      );
  }
  getUserDetails(accessToken) {
    var userDetailobj = {
      request: accessToken,
      XVERIFY: "test",
    };
    this.loaderService.display(true);

    this.http
      .post(this.baseUrl + "LoginAPI/GetUserDetails/", userDetailobj)
      .subscribe(
        (data) => {
          console.log(data);
          this.responseUserDetails = data;
          this.loaderService.display(false);
          //data.name,data.phoneNumber
          console.log(this.responseUserDetails);
          this.postUserDetails(this.responseUserDetails);
        },
        (error: any) => {
          console.log(error);
          this.loaderService.display(false);

        }
      );
  }
  postUserDetails(userdetails) {
    var postData = {
      MobileNumber: userdetails.data.phoneNumber,
      Name: userdetails.data.name,
      LoginType: "Phonepe",
      Email: userdetails.data.email != undefined ? userdetails.data.email : "",
    };
    console.log(postData);
    this.loaderService.display(true);

    this.http
      .post(this.baseUrl + "LoginAPI/PhonepeSilentLogin/", postData)
      .subscribe(
        (data) => {
          this.userDetails = data;
          this.loaderService.display(false);

          if (this.userDetails.statusCode == 1) {
            localStorage.setItem("customerId", this.userDetails.customerId);
            localStorage.setItem("customerName", this.userDetails.customerName);
            localStorage.setItem("isLoggedin", "true");
            //  localStorage.setItem("customerMobile", this.userDetails.MobileNumber);
            localStorage.setItem("customerMobile", this.userDetails.mobileNumber);

            console.log("login in now grocery via phone pe completed");
            window.location.href = ""
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
  }
}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/login/login.component.ts